class CategoriesService {
  getCategoryMetadataFieldsByType (category: TServiceCategory, type: TCategoryMetadataFieldType) {
    if (!category) {
      return []
    }

    return category.metadata.fields.filter(f => f.type === type)
  }

  getIsConditionMet (category: TServiceCategory, key: string, metadata: Record<string, unknown>) {
    if (category?.metadata?.conditions?.[key]?.alwaysHide) {
      return false
    }

    if (category?.metadata?.conditions?.[key]?.field) {
      return metadata[category.metadata.conditions[key].field] === category.metadata.conditions[key].value
    }

    return true
  }

  validateMetadataField (type: TCategoryMetadataFieldType, data: unknown) {
    const validationByType: TPartialRecord<TCategoryMetadataFieldType, (val: unknown) => boolean> = {
      location: (val) => {
        return !!(val as IAppLocation)?.location
      },
      number: (val) => {
        return typeof val === 'number' && Number.isFinite(val) && val >= 0
      }
    }

    if (validationByType[type]) {
      return validationByType[type](data)
    }

    return !!data
  }

  async getServiceCategories () {
    return apiClient.get('/api/categories/').then(res => res.categories)
  }
}

export const categoriesService = new CategoriesService()
